<template>
<div v-if="datesGroupSelectedStart && datesGroupSelectedEnd" 
    class="weekly-card time-line-tip">
    <p class="txt-333 txt-lh28 pt20 txt-center">
      {{datesGroupSelectedStart ? ('每周' + cNameOfWeekday(datesGroupSelectedStart.dayofweek)) : '选择上课时间'}}
    </p>
    <ul class="date-group-weekly-panel pt10 flex">
        <li class="item col-45">
            <a href="javascript:void(0);" class="txt-lh26 txt-666">
                首次课: {{formatDate(datesGroupSelectedStart.date, 'MM月dd日')}}
                <span v-if="datesGroupSelectedStart.today" class="date-extra-info">(今天)</span>
                <span  v-else-if="datesGroupSelectedStart.tomorrow" class="date-extra-info">(明天)</span>
                <span  v-else-if="datesGroupSelectedStart.thisweek" class="date-extra-info">(本周)</span>
                <span v-else-if="datesGroupSelectedStart.nextweek" class="date-extra-info">(下周)</span>
            </a>
        </li>
        <li class="item plr10 spe-item col-10"><span class="border-spe"></span></li>
        <li class="item col-45">
            <a href="javascript:void(0);" class="txt-lh26 txt-666">
                末次课: {{formatDate(datesGroupSelectedEnd.date, 'MM月dd日')}}
            </a>
        </li>
    </ul>
</div>
<div v-else 
     class="choose-time ptb40 txt-center" 
     @click="openMonthlyDatePicker">
    <p class="tip">{{emptyTitle || '选择上课时间'}}</p>
</div>
</template>
<style lang="less" src="./DateGroupWeeklyCard.less"></style>
<script>
export default {
  name: 'DateGroupWeeklyCard',
  props: {
    datesGroupSelectedStart: Object,
    datesGroupSelectedEnd: Object,
    emptyTitle: String
  },
  data(){
    return {}
  },
  methods: {
    cNameOfWeekday(dayofweek){
      var weeks = ['日', '一', '二', '三', '四', '五', '六'];
      return weeks[dayofweek % 7];
    },
    formatDate(date, format){
      var dateNormal = new Date(date.replace(/-/g, "/"));
      return utils.formatDate(dateNormal, format);
    },
    openMonthlyDatePicker(){
      this.$emit('openMonthlyDatePicker');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/DateGroupWeeklyCard.vue